import { PoolImage } from '../typesAndInterfaces/typesAndInterfaces';
import { axiosCaller } from './customAxios';
import { z } from 'zod';
import { PoolImageObj, PoolImageObjInfinitePagination } from '../utils/zod/zodObjects';
import { MB_InfinitePaginationPage } from '@/utils/general/util-hooks';

const imagePoolApiCalls = {
  uploadImage: async ({ formData, uploadProgress }: { formData: FormData; uploadProgress?: (percentCompleted: number) => void }): Promise<PoolImage> => {
    return await axiosCaller({
      path: '/api/imagePool/uploadImage',
      method: 'post',
      passToken: true,
      data: formData,
      responseValidatorObj: PoolImageObj,
      responseFormatValidatorMessage: 'Data mismatch for upload pool image response',
      responseDataKey: 'poolImage',
      onUploadProgress: progressEvent => {
        const percentCompleted = !progressEvent.total ? 0 : Math.round((progressEvent.loaded * 100) / progressEvent.total);
        uploadProgress?.(percentCompleted);
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  getImagePoolImages: async (totalItemsPerPage?: number, offset?: string, searchText?: string, folderId?: string): Promise<MB_InfinitePaginationPage<PoolImage>> => {
    return await axiosCaller({
      path: '/api/imagePool/getImages',
      method: 'get',
      responseValidatorObj: PoolImageObjInfinitePagination,
      responseFormatValidatorMessage: 'Data mismatch for get image pool images response',
      passToken: true,
      params: { totalItemsPerPage, offset, searchText, folderId },
    });
  },

  editImage: async (imageId: string, name: string, folderId?: string): Promise<string> => {
    return await axiosCaller({
      path: '/api/imagePool/editImage',
      responseValidatorObj: z.string(),
      responseFormatValidatorMessage: 'Data mismatch for edit image pool image response',
      responseDataKey: 'imageId',
      method: 'post',
      passToken: true,
      // folderId moves the image: a folder id, or '' to move back to the root.
      data: folderId === undefined ? { imageId, name } : { imageId, name, folderId },
    });
  },

  reorderImages: async (imagesOrder: { imageId: string; order: number }[]): Promise<void> => {
    await axiosCaller({
      path: '/api/imagePool/reorderImages',
      method: 'post',
      passToken: true,
      data: { imagesOrder },
    });
  },

  deleteImage: async (imageId: string): Promise<string> => {
    return await axiosCaller({
      path: '/api/imagePool/deleteImage',
      responseValidatorObj: z.string(),
      responseFormatValidatorMessage: 'Data mismatch for delete image pool images response',
      responseDataKey: 'imageId',
      method: 'post',
      passToken: true,
      params: { imageId },
    });
  },
};

export { imagePoolApiCalls };
